export default "__VITE_ASSET__EMpBTuda__"